<script>
  import { createEventDispatcher } from 'svelte';
  import { Checkbox, InlineNotification, Modal, TextArea } from 'carbon-components-svelte';

  import LoadingSpinner from '../../../components/LoadingSpinner.svelte';

  import { getServerErrorMessage } from '../../../utils';
  import { cancelRestoreRequest } from '../../../services';

  const dispatch = createEventDispatcher();

  export let open = false,
    restoreRequest,
    blocked = true;

  let resultNotification,
    approvalMessage = null,
    loading = false,
    understand = false;

  async function onFormSubmit() {
    if (!understand || blocked) {
      return;
    }

    resultNotification = null;
    loading = true;

    try {
      const approval = await cancelRestoreRequest(restoreRequest.id, { approvalMessage });
      loading = false;
      dispatch('close', approval);
    } catch (error) {
      const errorMessage = getServerErrorMessage(error) ?? 'Verify your submission and try again!';
      console.error('[ApprovalModal] Failed to cancel request!', errorMessage);
      resultNotification = {
        kind: 'error',
        title: 'Error:',
        subtitle: `Failed to cancel request! ${errorMessage}`,
      };
    } finally {
      loading = false;
    }
  }

  function handleClose() {
    if (loading) {
      return;
    }

    dispatch('close');
  }

  function onChange({ target: { value } }) {
    approvalMessage = value;
  }

  function stopPropagation(event) {
    event.stopPropagation();
  }

  function onCheck({ detail: checked }) {
    understand = checked;
  }
</script>

<Modal
  bind:open
  modalHeading="Cancel Request"
  primaryButtonText="Cancel Request"
  danger
  shouldSubmitOnEnter={false}
  preventCloseOnClickOutside
  primaryButtonDisabled={loading || !understand || blocked}
  on:click:button--secondary={handleClose}
  on:close={handleClose}
  on:submit={onFormSubmit}
>
  <LoadingSpinner {loading} small showOverlay>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
        hideCloseButton
      />
    {/if}
    <p class="main">Canceling this request will no longer allow anyone to approve or reject it.</p>
    <TextArea
      id="approvalMessage"
      name="approvalMessage"
      labelText="Your Rejection Note"
      value={approvalMessage}
      placeholder="Note for rejection..."
      on:change={onChange}
    />
    <div class="understand">
      <Checkbox
        labelText="I understand and I still want to cancel my request"
        checked={understand}
        on:click={stopPropagation}
        on:check={onCheck}
      />
    </div>
  </LoadingSpinner>
</Modal>

<style>
  .main {
    margin-bottom: 1rem;
  }

  .understand {
    margin-top: 1rem;
  }
</style>
